import { isI18nData } from './isI18nData';
import { isPlainObject } from './isPlainObject';

/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isTitleConfig(obj) {
  return isPlainObject(obj) && !isI18nData(obj);
}